import { fetchAuthSession } from '@aws-amplify/core';
import { initSentryFrontend } from '@chiroup/core/config/sentryFrontend';
import { Amplify, ResourcesConfig } from 'aws-amplify';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

// Initialize Sentry with shared configuration
initSentryFrontend({
  dsn: 'https://4e31ca6b060ff97a5d318de5b6ad29a8@o4506354335612928.ingest.sentry.io/4506356717977600',
  apiEndpoint: import.meta.env.VITE_HEALTHCOM_SCHEDULE_API as string,
  stage: import.meta.env.VITE_STAGE,
  version: import.meta.env.VITE_VERSION,
});

const authConfig: ResourcesConfig['Auth'] = {
  Cognito: {
    // allowGuestAccess: true,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID as string,
    userPoolClientId: import.meta.env.VITE_COGNITO_APP_CLIENT_ID as string,
    identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID as string,
  },
};

Amplify.configure(
  {
    Auth: authConfig,
    API: {
      REST: {
        api: {
          endpoint: import.meta.env.VITE_HEALTHCOM_SCHEDULE_API as string,
        },
        'api-noauth': {
          endpoint: import.meta.env.VITE_HEALTHCOM_SCHEDULE_API as string,
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async () => {
          // Only do this for api endpoint
          const authToken = (await fetchAuthSession()).tokens?.idToken?.toString();

          return {
            Authorization: `Bearer ${authToken}`,
          };
        },
        retryStrategy: {
          strategy: 'no-retry',
        },
      },
    },
  }
);

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);
root.render(
  // <StrictMode>
  <App />
  // </StrictMode>
);
